import React from 'react';
import './carousel.scss';
import { CarouselItem } from 'components/carousel/CarouselItem';

export const Carousel = ({ activeIndex, className, children }) => {
    const normalizedActiveIndex = activeIndex % children.length;
    const carouselClassName = `carousel ${className ?? ''}`;
    const getCarouselItemkey = childKey => `carousel_${childKey}`;

    const drawChildren = () =>
        React.Children.map(children, (child, index) => {
            return (
                <CarouselItem
                    currentIndex={normalizedActiveIndex}
                    isActive={index === normalizedActiveIndex}
                    key={getCarouselItemkey(child.key)}
                >
                    {child}
                </CarouselItem>
            );
        });

    return <div className={carouselClassName}>{drawChildren()}</div>;
};
